import { Col } from "antd";
import Introduction from "../components/KeyProcessesOverview/Introduction";
import Roadmap from "../components/KeyProcessesOverview/Roadmap";
import PageHeader from "../components/ui/PageHeader";
import { Icons } from "../assets/icons";
import { ICON_SIZE } from "../repository/data.default";
import FooterQuoteCard from "../components/ui/FooterQuoteCard";
import VideoSection from "../components/KeyProcessesOverview/VideoSection";

const footerText = (
  <p>
    The aim of the wellbeing policy and executed actions aim to ensure that
    employees are safe, healthy, satisfied and engaged in their work. Promoting
    wellbeing in the work environment can address and reduce risks of mental
    health disorders, alcohol and drug abuse, conflict and bullying while
    increase productivity, performance healthy behaviors, resilience, improve
    communication and relations making the workplace a more satisfying place to
    work for.
  </p>
);

function KeyProcessesOverviewPage() {
  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      {/* Header */}
      <PageHeader
        title={"OVERVIEW"}
        icon={
          <Icons.ActionsOverviewIcon width={ICON_SIZE} height={ICON_SIZE} />
        }
      />

      {/* Introduction Section */}
      <div className="mb-4">
        <Introduction />
      </div>

      {/* Roadmap Section */}
      <div className="mb-4 flex justify-center p-8 pb-32">
        <Roadmap />
      </div>

      {/* Video Section */}
      <div className="p-8 pb-32">
        <VideoSection />
      </div>

      <FooterQuoteCard
        icon={<Icons.OverviewFooterQuoteIcon width={350} height={350} />}
        text={footerText}
      />
    </Col>
  );
}

export default KeyProcessesOverviewPage;
